export const ERROR_MESSAGES = {
  0: 'common.errorMessages.serverError',
  400: 'common.errorMessages.badRequest',
  401: 'common.errorMessages.unauthorized',
  403: 'common.errorMessages.forbidden',
  404: 'common.errorMessages.notFound',
  500: 'common.errorMessages.serverError',
  default: 'common.errorMessages.unknown',
} as const;
